var _circle, _path, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#00703E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3848 7.00011L18.3383 18.2805L12.5 23",
    stroke: "#00703E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 18.5,
    x2: 32,
    y2: 18.5,
    stroke: "#00703E"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 35,
    x2: 18.5,
    y2: 32,
    stroke: "#00703E"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 4,
    x2: 18.5,
    y2: 1,
    stroke: "#00703E"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18.5,
    x2: 1,
    y2: 18.5,
    stroke: "#00703E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.36583daf8102dbc561ec7bf2f7894e09.svg";
export { ForwardRef as ReactComponent };